export default "__VITE_ASSET__8bb44c27__"